// Vendors
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const ERROR_COMPONENT_PROPS = {
  'image': 'illustration_emptystates_no-items',
  'data-testid': 'error-component',
  'variant': VARIANTS.EmptyStatusVariantType.DEFAULT,
};

export { ERROR_COMPONENT_PROPS };
